<div class="preview-report-container">
    <div class="preview-report-header">
        <div class="preview-report-title">{{ reportName }}</div>
        <div class="button-group">
            <button
                *ngIf="!hideDownload"
                class="aecom_btn--solid"
                (click)="downloadDoc()"
                [disabled]="isDownloading"
            >
                <ng-container *ngIf="!isDownloading; else downloading">
                    Download
                </ng-container>
                <ng-template #downloading>
                    <span class="download-loading">
                        Downloading
                        <span class="dots">
                            <span>.</span>
                            <span>.</span>
                            <span>.</span>
                        </span>
                    </span>
                </ng-template>
            </button>
            <button class="aecom_btn" (click)="closePreview()">
                Close
            </button>
        </div>

    </div>
    <div class="preview-report-content">
        <ng2-pdfjs-viewer [pdfSrc]="aecomReport" [theme]="'auto'" [downloadFileName]="reportName" [download]="false" [urlValidation]="false">
        </ng2-pdfjs-viewer>
    </div>
</div>